import React from 'react';
import { TableStatistics as TableStatisticsComponent } from '../../modules';
import StatisticsContainer from './StatisticsContainer';

const TableStatistics = () => (
    <StatisticsContainer>
        <TableStatisticsComponent />
    </StatisticsContainer>
);

export default TableStatistics;